<template>
    <div class="prebuilt-entity">
        <div v-if="isEntitySupported">
          <or-select
            :label="$t('model.nlu-model.sidebar.entities.editors.prebuilt-entity.prebuiltentity.selectPrebuiltEntity.label')"
            v-model="localEntity.name"
            class="entity-name"
            :class="{ 'not-allowed': !canEdit }"
            :disabled="!canEdit"
            :help="helpText"
            :options="allPrebuiltEntities.value"
          />
          <or-chips
            :label="$t('model.nlu-model.sidebar.entities.editors.prebuilt-entity.prebuiltentity.roles.label')"
            :helpText="$t('model.nlu-model.sidebar.entities.editors.prebuilt-entity.prebuiltentity.roles.label')"
            :simpleText="true"
            :error="$props.errors.roles"
            :invalid="!!$props.errors.roles"
            :value="localEntity.roles"
            @input="updateRoles"
          />
        </div>
        <div v-else class="not-supported-entity">
          {{ $t('model.nlu-model.sidebar.entities.editors.prebuilt-entity.prebuiltentity.prebuiltEntitiesAre') }}
        </div>
        <!-- <or-checkbox-group
            v-model="localEntity"
            :disabled="allPrebuiltEntities.loading || $props.isLoading"
            :options="allPrebuiltEntities.value"
            vertical
        /> -->
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { ENTITY_TYPE } from '../../entity-types'

export const getDefaultPreBuildEntity = () => ({
  name: '',
  roles: [],
  type: ENTITY_TYPE.prebuilt
})
export default {

  props: {
    isLoading: Boolean,
    errors: Object,
    isNewEntity: {
      type: Boolean,
      default: false
    },
    selectedPrebuildEntities: Object,
    isEntitySupported: Boolean
  },

  computed: {
    ...mapState('knowledgebase/entities', ['allPrebuiltEntities']),
    ...mapState('knowledgebase', ['utterances']),

    helpText () {
      if (this.canEdit) {
        return ''
      }
      return this.$t(
        'model.nlu-model.sidebar.entities.editors.prebuilt-entity.prebuiltentity.selectPrebuiltEntity.disabledHelpText'
      )
    },

    canEdit () {
      if (this.$props.isNewEntity) {
        return true
      }

      return !this.utterances.value.some(utterance => {
        if (utterance.entityPredictions) {
          return utterance.entityPredictions.some(entity => entity.entityName === this.localEntity.name)
        }
        return false
      })
    },

    localEntity: {
      get () {
        return this.$props.selectedPrebuildEntities
      },
      set (entitiesNames) {
        this.$emit('update:selectedPrebuildEntities', entitiesNames)
      }
    }
  },

  methods: {
    updateRoles (roles) {
      this.localEntity.roles = roles.map(role => role.replace(/`/g, ''))
    }
  }
}
</script>

<style scoped lang="scss">
.entity-name {
  &.not-allowed {
    cursor: not-allowed;
    ::v-deep .ui-select__display {
      cursor: not-allowed;
    }
  }
}
.not-supported-entity {
    margin: 8px;
    margin-top: 32px;
    color: rgb(145, 150, 157);
    font-size: 14px;
    font-weight: normal;
    text-align: center;
}
</style>
